<template>
  <div id="app">
    <img src="https://cdn1.joloservice.com/wxShare/youshangshare.jpg" alt="logo" />
    <div style="display: flex;justify-content: center;margin-top: 10px;">点击右上角分享好友</div>
    <div class="share-preview-divider">
      <span class="line"></span>
      <div class="content">
        <img src="https://cdn1.joloservice.com/wxShare/weixin.png" alt="微信" />
        <span>分享预览</span>
      </div>
      <span class="line"></span>
    </div>
    <div class="share-card">
      <div class="share-text">
        <p class="share-title">{{ shareData.title }}</p>
        <p class="share-desc">{{ shareData.desc }}</p>
      </div>
      <img :src="shareData.imgUrl" class="share-image" alt="游戏图标" />
    </div>
    <div class="share-preview-divider">
      <span class="line"></span>
      <div class="content">
        <img src="https://cdn1.joloservice.com/wxShare/peng.png" alt="朋友圈" />
        <span>分享预览</span>
      </div>
      <span class="line"></span>
    </div>
    <div class="game-tag-card">
      <img class="game-icon"  :src="shareData.imgUrl" alt="游戏图标" />
      <span class="game-text">{{ shareData.title }}</span>
    </div>

  </div>
</template>

<script>
import wxShare from './utlis/wxShare'
import CryptoJS from 'crypto-js'
import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      shareData: {
        title: '',
        desc: '',
        linkurl: '',
        imgUrl: ''
      }
    }
  },
  mounted () {
    const array = new Uint8Array(16)
    window.crypto.getRandomValues(array)
    const randomBytes = Array.from(array).map(b => b.toString(16).padStart(2, '0')).join('')

    const getJsapiTicket = async () => {
      const newTicket = await fetchNewJsapiTicket()
      localStorage.setItem('jsapi_ticket', newTicket)
      localStorage.setItem('jsapi_ticket_time', Math.floor(Date.now() / 1000).toString())
      return newTicket
    }

    const fetchNewJsapiTicket = async () => {
      try {
        const accessTokenResponse = await axios.get('/cgi-bin/token', {
          params: {
            grant_type: 'client_credential',
            appid: 'wx333bc01b2592f335',
            secret: 'aa8e6e45617e4f63f3bf51c52231432b'
          }
        })
        const accessToken = accessTokenResponse.data.access_token
        const jsapiTicketResponse = await axios.get('/cgi-bin/ticket/getticket', {
          params: {
            access_token: accessToken,
            type: 'jsapi'
          }
        })
        return jsapiTicketResponse.data.ticket
      } catch (error) {
        console.error('Error fetching jsapi_ticket:', error)
        return null
      }
    }

    const generateSignature = (jsapi_ticket, nonceStr, timeStamp, url) => {
      const params = {
        jsapi_ticket,
        noncestr: nonceStr,
        timestamp: timeStamp,
        url
      }
      const sortedKeys = Object.keys(params).sort()
      const string1 = sortedKeys.map(key => `${key}=${params[key]}`).join('&')
      return CryptoJS.SHA1(string1).toString()
    }

    const initWxConfig = async () => {
      const jsapi_ticket = await getJsapiTicket()
      const url = window.location.href.split('#')[0]
      const timeStamp = Math.floor(Date.now() / 1000).toString()
      const nonceStr = randomBytes
      const signature = generateSignature(jsapi_ticket, nonceStr, timeStamp, url)

      const urlParams = new URLSearchParams(window.location.search)
      const gameId = urlParams.get('gameId')
      const url6 = urlParams.get('url')

      const data = { id: gameId }
      const gameInfo = await axios.post(`${url6}/api/game/getGameInfo`, data)

      const shareData = {
        title: gameInfo.data.data.title,
        desc: gameInfo.data.data.desc,
        linkurl: gameInfo.data.data.linkurl,
        imgUrl: gameInfo.data.data.imgUrl
      }

      this.shareData = shareData
      wxShare.getJSSDK({
        appId: 'wx333bc01b2592f335',
        timeStamp,
        nonceStr,
        signature
      }, shareData)
    }

    initWxConfig()
  }
}
</script>
<style>
.share-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 20px auto;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.share-text {
  flex: 1;
  text-align: left;
  padding-right: 12px;
}

.share-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.share-desc {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  line-height: 1.4;
}

.share-image {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  flex-shrink: 0;
  object-fit: cover;
}

.share-preview-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto;
  width: 90%;
  max-width: 500px;
}

.share-preview-divider .line {
  flex: 1;
  height: 1px;
  background-color: #e0e0e0;
  margin: 0 10px;
}

.share-preview-divider .content {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.share-preview-divider .content img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.game-tag-card {
  display: flex;
  align-items: center;
  background-color: #f7f7f7;
  border: 1px solid #00a4ff;
  border-radius: 12px;
  padding: 10px 14px;
  max-width: 400px;
  margin: 20px auto;
  box-sizing: border-box;
}

.game-tag-card .game-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  margin-right: 12px;
  object-fit: cover;
}

.game-tag-card .game-text {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}
</style>
